import { render, staticRenderFns } from "./CertificateFormGlobal.vue?vue&type=template&id=75a6069f&"
import script from "./CertificateFormGlobal.vue?vue&type=script&lang=js&"
export * from "./CertificateFormGlobal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75a6069f')) {
      api.createRecord('75a6069f', component.options)
    } else {
      api.reload('75a6069f', component.options)
    }
    module.hot.accept("./CertificateFormGlobal.vue?vue&type=template&id=75a6069f&", function () {
      api.rerender('75a6069f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/routing/global/CertificateFormGlobal.vue"
export default component.exports